import AggregateError from '@ardatan/aggregate-error';
import { getErrorsByPathSegment, relocatedError } from '@graphql-tools/utils';
export function handleNull(errors) {
    if (errors.length) {
        if (errors.some(function (error) { return !error.path || error.path.length < 2; })) {
            if (errors.length > 1) {
                var combinedError = new AggregateError(errors);
                return combinedError;
            }
            var error = errors[0];
            return error.originalError || relocatedError(error, null);
        }
        else if (errors.some(function (error) { return typeof error.path[1] === 'string'; })) {
            var childErrors_1 = getErrorsByPathSegment(errors);
            var result_1 = {};
            Object.keys(childErrors_1).forEach(function (pathSegment) {
                result_1[pathSegment] = handleNull(childErrors_1[pathSegment]);
            });
            return result_1;
        }
        var childErrors_2 = getErrorsByPathSegment(errors);
        var result_2 = [];
        Object.keys(childErrors_2).forEach(function (pathSegment) {
            result_2.push(handleNull(childErrors_2[pathSegment]));
        });
        return result_2;
    }
    return null;
}
//# sourceMappingURL=handleNull.js.map